import { SITE_ORIGIN } from "../../../config/site";
import L from "../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../constants/trial";

/** Заголовок вкладки и og:title (без суффикса — добавится в Seo). */
export const LANDING_PAGE_TITLE = L.productTagline;

export const LANDING_PAGE_DESCRIPTION =
  `${L.productName} — платформа для спортивных секций: соцсеть участников, брендинг под ваш клуб, ` +
  `журнал посещаемости, абонементы и финансы. PWA на телефоне. ${TRIAL_DAYS} дней бесплатно.`;

export const LANDING_PAGE_KEYWORDS = [
  L.productName,
  "CRM для спортивного клуба",
  "CRM для тренера",
  "спортивная секция",
  "журнал посещаемости",
  "абонементы",
  "расписание тренировок",
  "PWA для клуба",
  "приложение спортивного клуба",
  "учёт клиентов секции",
];

/** Open Graph — абсолютный URL. */
export const LANDING_OG_IMAGE = `${SITE_ORIGIN}/icons/icon-512.png`;

function buildLandingJsonLdWithDescription(description) {
  return [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: L.productName,
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      url: SITE_ORIGIN,
      description,
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "RUB",
        description: `${TRIAL_DAYS} дней бесплатного пробного периода`,
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: L.productName,
      url: SITE_ORIGIN,
      logo: LANDING_OG_IMAGE,
      description: L.productTagline,
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: L.productName,
      url: SITE_ORIGIN,
      description,
      inLanguage: "ru-RU",
    },
  ];
}

export function buildLandingJsonLd() {
  const description = LANDING_PAGE_DESCRIPTION.slice(0, 300);
  return buildLandingJsonLdWithDescription(description);
}

// --- Лендинг: приложение клуба ---
export const APP_LANDING_PAGE_TITLE = "Создать приложение для спортивного клуба";
export const APP_LANDING_PAGE_DESCRIPTION =
  `Baysport — приложение клуба на телефоне клиентов (PWA), соцсеть участников, персонализация под бренд и ` +
  `CRM для журнала, абонементов и финансов. ${TRIAL_DAYS} дней бесплатно.`;
export const APP_LANDING_PAGE_KEYWORDS = [
  "создать приложение для спортивного клуба",
  "приложение для фитнес клуба",
  "PWA для клуба",
  "соцсеть для спортивной секции",
  "CRM с приложением",
  "брендирование CRM",
];
export function buildAppLandingJsonLd() {
  const description = APP_LANDING_PAGE_DESCRIPTION.slice(0, 300);
  return buildLandingJsonLdWithDescription(description);
}

// --- Лендинг: CRM для спорта ---
export const CRM_LANDING_PAGE_TITLE =
  "CRM для спортивного клуба: клиенты, абонементы, журнал";
export const CRM_LANDING_PAGE_DESCRIPTION =
  `CRM Baysport для спортивных секций: клиенты и абонементы, календарь и журнал, финансы и аналитика. ` +
  `Соцсеть участников и брендирование — внутри платформы. ${TRIAL_DAYS} дней бесплатно.`;
export const CRM_LANDING_PAGE_KEYWORDS = [
  "crm для спортивного клуба",
  "crm для спортивной секции",
  "crm для тренера",
  "журнал посещаемости",
  "абонементы и финансы",
  "white label crm для спорта",
];
export function buildCrmLandingJsonLd() {
  const description = CRM_LANDING_PAGE_DESCRIPTION.slice(0, 300);
  return buildLandingJsonLdWithDescription(description);
}
